import {useState} from "react";
import GeneralBody from "@/components/pages/GeneralBody.tsx";
import TeamInvite from "@/components/pages/TeamInvite.tsx";


export default function DashboardTabs() {
    type DropdownProps = {
        label: string;
        component: JSX.Element;
    };
    const [dropdownItemIndex, setDropdownItemIndex] = useState(0);

    const dropdown: DropdownProps[] = [
        {label: "General", component: <GeneralBody/>},
        {label: "Teams", component: <TeamInvite/>},

    ];
    return (
        <>
            <div className="app-content">
                <div className="tabs-menu" role="tablist">
                    {dropdown.map((item, index) => {
                        return (
                            <a data-w-tab={`Tab ${index + 1}`}
                               className={`tab w-inline-block w-tab-link ${dropdownItemIndex == index && "activeTab"}`}
                               tabIndex={-1}
                               id={`w-tabs-${index}-data-w-tab-${index}`}
                               role="tab"
                               onClick={() => setDropdownItemIndex(index)}
                            >
                                <div>{item.label}</div>
                            </a>
                        );
                    })}
                </div>
                {dropdown[dropdownItemIndex].component}
            </div>
        </>
    );
}
